import { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SuSyApi } from '../../api/susyApi';
import { IChangeLog } from '../../definitions/interfaces/IChangelog';
import { RootState } from '../../store/index';
import NewReleaseModal from '../../components/shared/newReleaseModal/NewReleaseModal';
interface IProps {
    children: ReactNode;
}

export const DisplayReleaseChanges = ({ children }: IProps) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [changeLog, setChangeLog] = useState<IChangeLog | null>(null);

    const currentUser = useSelector(
        (state: RootState) => state.auth.currentUser
    );

    const navigate = useNavigate();

    useEffect(() => {
        const getCurrentChangeLog = async () => {
            return await SuSyApi.get('releaseChangelog/latestChangelog');
        };
        if (currentUser) {
            getCurrentChangeLog().then((response) => {
                const changeLog = response.data.changeLog;

                setChangeLog(changeLog);

                if (currentUser.lastSeenVersion !== changeLog.versionNumber) {
                    setShowModal(true);
                }
            });
        }
    }, [currentUser]);

    const updateLastSeenVersion = async () => {
        await SuSyApi.put(`user/lastSeenVersion/${changeLog?.versionNumber}`);
    };

    const onHideModal = async () => {
        setShowModal(false);
        await updateLastSeenVersion();
    };

    const onReadFullChangelog = () => {
        const userRole = currentUser?.userRole.key.toLowerCase();
        navigate(`${userRole}/changelog`);
        onHideModal();
    };

    return (
        <>
            {showModal && changeLog && (
                <NewReleaseModal
                    showModal={showModal}
                    onHide={onHideModal}
                    onReadFullChangelog={onReadFullChangelog}
                    changelog={changeLog}
                ></NewReleaseModal>
            )}

            {children}
        </>
    );
};
